import { useQuery } from '@tanstack/react-query'

import {
  getInsuranceById,
} from '@flecto/api/saas'
import { type ParameterID } from '@flecto/types'

export function useQueryGetInsuranceById(insuranceId: ParameterID) {
  return useQuery({
    queryKey: ['QueryGetInsuranceById', `${insuranceId}`],
    queryFn: async () => await getInsuranceById(insuranceId),
    enabled: Boolean(insuranceId),
  })
}
